import { FC, ChangeEvent } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import cleanText from 'utils/cleanText';

import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

const SubjectSection: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSendCommunicationModal();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const sanitizedText = cleanText(event.target.value);
    actions.handleChangeSubject(sanitizedText);
  };

  return (
    <input
      id="communication-subject"
      type="text"
      className="subject-input mt-3"
      placeholder={t('Subject')}
      value={data.subject}
      onChange={handleChange}
    />
  );
};

export default SubjectSection;
